"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = _default;

var _aspectRatios = _interopRequireDefault(require("./aspectRatios")),
    _durations = _interopRequireDefault(require("./durations")),
    _rushEdit = _interopRequireDefault(require("./rushEdit")),
    _captions = _interopRequireWildcard(require("./captions")),
    _chromaKey = _interopRequireDefault(require("./chromaKey")),
    _videoOutput = _interopRequireDefault(require("./videoOutput"));

function _default() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      b = a.isInternal;
  return {
    ASPECT_RATIOS: (0, _aspectRatios["default"])(),
    DURATIONS: (0, _durations["default"])(),
    RUSH_EDIT: (0, _rushEdit["default"])(),
    CAPTIONS: (0, _captions["default"])(),
    VIDEO_OUTPUT: (0, _videoOutput["default"])(),
    CAPTION_SAMPLES: _captions.CAPTION_SAMPLES,
    CHROMA_KEY: (0, _chromaKey["default"])({
      isInternal: b
    })
  };
}